/**
 * Normalizes optional Stitch-style layout fields so CORE guides get hero/sidebar
 * without duplicating data on every article object.
 * @param {object} article guide entry from GUIDE_ARTICLES
 */
export function getGuideLayoutDefaults(article) {
  const L = article.listing || {};
  const desc = typeof article.description === 'string' ? article.description : '';
  const heroSubtitle =
    article.heroSubtitle ||
    (desc.length > 180 ? `${desc.slice(0, 177).trim()}…` : desc) ||
    article.title;

  const tips =
    article.sidebarTips && article.sidebarTips.length > 0
      ? article.sidebarTips
      : [
          'Book refundable or flexible hotels early for match weeks.',
          'Screenshot transit maps before stadium day—cell networks get crowded.',
          'Leave buffer after night games (stoppage time, VAR, extra time).',
        ];

  const warnings =
    article.sidebarWarnings && article.sidebarWarnings.length > 0
      ? article.sidebarWarnings
      : [
          'Tight dinner reservations before kickoff',
          'Assuming rideshare pickup at the main gate after full time',
          'Ignoring official bag and security rules for your venue',
        ];

  return {
    heroImage: article.heroImage || L.coverImage || null,
    heroImageAlt: article.heroImageAlt || article.title || 'Guide cover',
    heroBadge: article.heroBadge || L.displayTag || 'Fan guide',
    heroSubtitle,
    heroAccent: article.heroAccent || null,
    sidebarTips: tips,
    sidebarWarnings: warnings,
  };
}
